import request from '@/utils/request'

// 公开接口：获取AI等级列表（无需登录）
export function getAiLevels() {
    return request({
        url: '/swx/customer/ai/levels',
        method: 'get'
    })
}

// 获取AI信息（状态+匹配等级+所有等级）
export function getAiInfo() {
    return request({
        url: '/swx/customer/ai/info',
        method: 'post'
    })
}

// 激活AI投资
export function activateAi() {
    return request({
        url: '/swx/customer/ai/activate',
        method: 'post'
    })
}

// 关闭AI投资
export function deactivateAi() {
    return request({
        url: '/swx/customer/ai/deactivate',
        method: 'post'
    })
}

// AI收益记录
export function getAiProfitRecords(params) {
    return request({
        url: '/swx/customer/ai/profitRecords',
        method: 'get',
        params
    })
}
